/* Restock date notice (LS Silk, draft 2026-10-21). Dawn re-renders only a few ids on a variant change; this copies
   the notice, the hidden "Pre-order" line-item property and the button label from the freshly rendered section. */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var d = (event && event.data) || {};
    if (!d.html || !d.sectionId) return;
    var sid = d.sectionId;
    var src = d.html.getElementById('Restock-' + sid);
    var dst = document.getElementById('Restock-' + sid);
    if (!src || !dst) return;
    dst.innerHTML = src.innerHTML;
    dst.hidden = src.hasAttribute('hidden');
    var sp = d.html.getElementById('RestockProp-' + sid);
    var dp = document.getElementById('RestockProp-' + sid);
    if (sp && dp) { dp.value = sp.value; dp.disabled = sp.hasAttribute('disabled'); }
    var btn = document.getElementById('ProductSubmitButton-' + sid);
    var label = btn && btn.querySelector('span');
    if (label && !btn.hasAttribute('disabled') && !dst.hidden) label.textContent = 'Pre-order';
    var box = btn && btn.closest('.product-form__buttons');
    if (box) box.classList.toggle('rs-preorder', !dst.hidden);
    // express checkout hidden on a pre-order -> the Pre-order button becomes the main (solid) button
    if (btn && box && box.querySelector('.shopify-payment-button')) {
      btn.classList.toggle('button--primary', !dst.hidden);
      btn.classList.toggle('button--secondary', dst.hidden);
    }
  });
})();
